// const appId = process.env.SQUARE_APPLICATION_ID;
const appId = window.SQUARE_APPLICATION_ID;
const locationId = undefined;

async function initializeCard(payments) {
  const card = await payments.card();
  await card.attach('#card-container');
  console.log("initializeCard done")
  return card;
}

async function tokenize(paymentMethod) {
  const tokenResult = await paymentMethod.tokenize();
  if (tokenResult.status === 'OK') {
    console.log("tokenize done")
    return tokenResult;
  } else {
    let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
    if (tokenResult.errors) {
      errorMessage += ` and errors: ${JSON.stringify(
        tokenResult.errors
      )}`;
    }
    throw new Error(errorMessage);
    return errorMessage
  }
}

document.addEventListener('DOMContentLoaded', async function () {
  console.log("square_payment loaded")
  if (!window.Square || !document.getElementById("card-container")) {
    return;
  }
  let payments;
  try {
    payments = window.Square.payments(appId, locationId);
  } catch (e) {
    const statusContainer = document.getElementById(
      'payment-status-container'
    );
    statusContainer.className = 'missing-credentials';
    statusContainer.style.visibility = 'visible';
    console.error(e);

    return;
  }

  let card;
  try {
    card = await initializeCard(payments);
  } catch (e) {
    console.error('Initializing Card failed', e);
    return;
  }

  // Checkpoint 2.
  async function handlePaymentMethodSubmission(paymentMethod) {
    const tokenResult = await tokenize(paymentMethod);
    // nonceの値をhiddenの中に入れます
    document.getElementById('payment_card_nonce').value = tokenResult.token;
    document.getElementById('payment_brand').value = tokenResult.details.card.brand;
    document.getElementById('payment_last4').value = tokenResult.details.card.last4;
    document.getElementById('payment_exp_month').value = tokenResult.details.card.expMonth;
    document.getElementById('payment_exp_year').value = tokenResult.details.card.expYear;
    console.log("set params done")
  }

  const cardButton = document.getElementById('order_submit_btn');
  cardButton.addEventListener('click', async function (event) {
    try {
      event.preventDefault();
      const form = document.getElementById('orders_new_form')

      if (form.reportValidity()) { // viewのformのバリデーション（requireとか）
        cardButton.disabled = true;
        await handlePaymentMethodSubmission(card);
        // 本来のフォームを送信します
        form.submit();
      }

    } catch (e) {
      console.error(e.message);
      cardButton.disabled = false;
    }
  });
});
